import Row from '@amzn/meridian/row';
import React from 'react';
import { useIntl } from 'react-intl';

import { User } from '../../../../Types';
import * as colors from '../../../../Util/Colors';
import { Feature, isFeatureEnabled } from '../../../../config/FeaturesConfig';
import LegendIcon from '../CustomLegendIcon';

interface CustomLegendProps {
  user: User;
  payload: Record<string, any>[];
  isProfileTm: boolean;
  type: string;
}

const CustomLegend: React.FC<CustomLegendProps> = ({
  user,
  payload,
  isProfileTm,
  type,
}: CustomLegendProps): React.ReactElement => {
  const intl = useIntl();
  payload.reverse();

  const legacyExperience = !isFeatureEnabled(Feature.LIGHTHOUSE);

  return (
    <Row spacingInset='300 none none' spacing='none'>
      {payload.map((entry: any) => {
        const { dataKey, color } = entry;
        // eslint-disable-next-line array-callback-return
        if (legacyExperience && dataKey === `networkAverage`) return;
        let value = '';
        let fill = '';

        if (dataKey === 'datapoint') {
          value = isProfileTm
            ? (value = intl.formatMessage({
                id: 'cs_perfportal_my_team',
                defaultMessage: 'My Team',
              }))
            : user.displayName;
          fill = colors.primaryFill;
        } else if (dataKey === `networkAverage`) {
          value = intl.formatMessage({
            id: 'cs_perfportal_network_benchmark',
            defaultMessage: 'Network Benchmark',
          });
          fill = colors.secondaryFill;
        }

        return (
          <LegendIcon
            fill={fill}
            color={color}
            value={value}
            key={`icon_${type}`}
          />
        );
      })}
    </Row>
  );
};

export default CustomLegend;
